export default __webpack_public_path__ + "1eba5013e0cc927c7be65ae57e775304.glb";